module.exports = __webpack_public_path__ + "0220cf41b70fe27fc8020a4ff906f39e.png";